import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import { Container, Col } from 'reactstrap';
import styles from './styles.module.scss';
import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';

export default function SolutionsAccordion({
    global,
    pathPrefix,
    customClass = "",
    content,
    post
}) {
    // Create a state variable to track the open accordion item and its toggle class
    const [openItem, setOpenItem] = useState(null);

    const classToggle = (id) => {
        // If the clicked item is already open, close it
        if (openItem === id) {
            setOpenItem(null);
        } else {
            // Otherwise, open the clicked item
            setOpenItem(id);
        }
    };

    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    return (
        <section className={`${styles.root} ${customClass}`}>
            <Container>
                {content ?
                    <div className="mb-5 heading">
                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                            {content}
                        </SourceFlowText>
                    </div> : ""}
                <Accordion open={open} toggle={toggle} className="row m-0">
                    {post?.map((post, index) => (
                        <Col key={index} md={6} lg={4} className={`mb-4 item rounded-4 ${open === `${index}` ? "open" : ""}`}>
                            <AccordionItem className={`border-0 bg-transparent position-relative`}>
                                <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className="mb-4"
                                    onClick={() => classToggle(`${index}`)}
                                >
                                    {post?.title}
                                </AccordionHeader>
                                <div>
                                    {post?.short_description ?
                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                    : null}
                                </div>
                                <AccordionBody accordionId={`${index}`}>
                                    {post?.content ?
                                        <div className="" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                    : null}
                                </AccordionBody>
                            </AccordionItem>
                        </Col>
                    ))}
                </Accordion>
            </Container>
        </section>

    )
}